import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../MyComponents/Footer";
// import GuestNav from "../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../MyComponents/Hero2";
import heroContent from "./HeroContent";
import "./CodingPortal.css";
import CourseExplorer from "../../MyComponents/CourseExplorer";
import leftimg from "../../assets/Codingleftimg.png";
import rightimg from "../../assets/Codingrightimg.png";
// import scratchimg from "../../assets/Scratchimg.png";
// import appimg from "../../assets/Appimg.png";
// import webimg from "../../assets/Webimg.png";
// import pythonimg from "../../assets/pythonimg.png";
// import cppimg from "../../assets/C++img.png";
// import unityimg from "../../assets/Unitygameimg.png";
// import machineimg from "../../assets/Machineimg.png";
// import databaseimg from "../../assets/Databaseimg.png";
// import androidimg from "../../assets/Androidimg.png";
// import AIimg from "../../assets/AIpromptimg.png";
// import phpimg from "../../assets/PHPimg.png";
// import gameimg from "../../assets/Gameimg.png";
// import datascienceimg from "../../assets/AIimg.png";
import CourseSection from "../../MyComponents/CourseSection";
import LearningStyle from "../../MyComponents/LearningStyle";
import Testimonials from "../../MyComponents/Testimonials";
import FAQs from "../../MyComponents/FooterPages/newfaq";
import HeadSection from "../HeadSection.js";
import pencilIcon from "../../assets/pencil.png";
import API_CONFIG from "../../config/api";
import { Link } from "react-router-dom";
import "../../MyComponents/PopularCourses.css";
import { useNavigate } from 'react-router-dom/dist/umd/react-router-dom.development';
import icon1 from "../../assets/Coding/scratch.png"
import icon2 from "../../assets/Coding/Vector.png"
import icon3 from "../../assets/Coding/Group 1686552240.png"
import icon4 from "../../assets/Coding/Group 1686552237.png"
import icon5 from "../../assets/Coding/Group.png"
import icon6 from "../../assets/Coding/Group 1686552236.png"
import icon7 from "../../assets/Coding/Group 1686552235.png"
import icon8 from "../../assets/Coding/Clip path group-1.png"
import icon9 from "../../assets/Coding/Group-1.png"
import icon10 from "../../assets/Coding/Clip path group-2.png"
import icon11 from "../../assets/Coding/Group 1686552238.png"
import icon12 from "../../assets/Coding/download (69) 1.png"
import icon13 from "../../assets/Coding/Group-2.png"
import img1 from "../../assets/Coding/Rectangle 5.png"
import img2 from "../../assets/Coding/Group 22.png"
import img3 from "../../assets/Coding/Rectangle 5-1.png"
import img4 from "../../assets/Coding/Group 22-1.png"
import img5 from "../../assets/Coding/Rectangle 5-2.png"
import img6 from "../../assets/Coding/Group 22-2.png"
import img7 from "../../assets/Coding/Rectangle 5-3.png"
import img8 from "../../assets/Coding/Group 22-3.png"
import img9 from "../../assets/Coding/Group 22-4.png"
import img10 from "../../assets/Coding/Group 22-5.png"
import img11 from "../../assets/Coding/Rectangle 5-4.png"
import img12 from "../../assets/Coding/Rectangle 5-5.png"
import img13 from "../../assets/Coding/Group 22-6.png"





// Course data
const courses = [
  {
    title: "Scratch Programming",
    image: "Polymath-images/Coding/Group 22.png",
    icon: "Polymath-images/Coding/adobe_xd_elements_logo.png.png",
    color: "#ffde24ff",
    age: "Age: 12+",
    link: "/coding_scratch"
  },
  {
    title: "App Development",
    image: "Polymath-images/Coding/Rectangle 5.png",
    icon: "Polymath-images/Coding/Group.png",
    color: "#1f7c08ff",
    age: "Age: 12+",
    link: "/coding_app_development"
  },
  {
    title: "Web Development",
    image: "Polymath-images/Coding/Rectangle 5-1.png",
    icon: "Polymath-images/Coding/ri_code-box-fill.png",
    color: "#66c0ccff",
    age: "Age: 12+",
    link: "/coding_web_development"
  },
  {
    title: "Game Development",
    image: "Polymath-images/Coding/Rectangle 5-2.png",
    icon: "Polymath-images/Coding/Group 1686552237.png",
    color: "#d4149aff",
    age: "Age: 12+",
    link: "/coding_game_development"
  },
  {
    title: "PHP Procedural Programming",
    image: "Polymath-images/Coding/Rectangle 5-3.png",
    icon: "Polymath-images/Coding/Clip path group-1.png",
    color: "#9956bbff",
    age: "Age: 12+",
    link: "/coding_php"
  },
  {
    title: "AI and data Science",
    image: "Polymath-images/Coding/Rectangle 5-4.png",
    icon: "Polymath-images/Coding/Clip path group-5.png",
    color: "#ffde24ff",
    age: "Age: 12+",
    link: "/coding_ai_datascience"
  },
  {
    title: "Python Programming",
    image: "Polymath-images/Coding/Group 22-1.png",
    icon: "Polymath-images/Coding/Group 1686552235.png",
    color: "#66c0ccff",
    age: "Age: 12+",
    link: "/coding_python"
  },
  {
    title: "C++ Programming",
    image: "Polymath-images/Coding/Rectangle 5-5.png",
    icon: "Polymath-images/Coding/Clip path group-2.png",
    color: "#1f7c08ff",
    age: "Age: 12+",
    link: "/coding_cplus"
  },
  {
    title: "Unity Game Development",
    image: "Polymath-images/Coding/Rectangle 5-6.png",
    icon: "Polymath-images/Coding/Clip path group-3.png",
    color: "#d4149aff",
    age: "Age: 12+",
    link: "/coding_game_dev_unity"
  },
  {
    title: "Machine Learning",
    image: "Polymath-images/Coding/Group 22-2.png",
    icon: "Polymath-images/Coding/Clip path group-4.png",
    color: "#ffde24ff",
    age: "Age: 12+",
    link: "/coding_machine_learning"
  },
  {
    title: "Database Management (Coming Soon)",
    image: "Polymath-images/Coding/Rectangle 5-7.png",
    icon: "Polymath-images/Coding/Group 1686552238.png",
    color: "#AA66CC",
    age: "Age: 12+",
    link: null
  },
  {
    title: "Android App Development",
    image: "Polymath-images/Coding/Group 22-3.png",
    icon: "Polymath-images/Coding/Group.png",
    color: "#1f7c08ff",
    age: "Age: 12+",
    link: "/coding_app_dev_androidstu"
  },
  {
    title: "AI Prompt Engineering",
    image: "Polymath-images/Coding/Group 22-4.png",
    icon: "Polymath-images/Coding/Group 1686552236.png",
    color: "#66c0ccff",
    age: "Age: 12+",
    link: "/coding_ai_promptengineer"
  }



];
const CodingPopularCourses = () => {
  const navigate = useNavigate();

  const handleBookDemoClick = () => {
    navigate("/BookADemo");
  };
  return (
    <div className="stem-container">
      <h1 className="stem-title-1">Explore Our Fun & Skill-Boosting </h1>
      <h1 className="stem-title">Coding Courses</h1>
      <div className="courses-grid">
        {courses.map((course) => (
          <div key={course.title} className="course-card">
            <Link to={course.link} className="course-link">

              <div className="course-image-container">
                <img
                  src={`${API_CONFIG.IMAGES_URL}/${course.image}`}
                  alt={course.title}
                  className="course-image"
                />
                <span className="ages-badge">{course.age}</span>
              </div>

              <div className="icon-container" style={{ backgroundColor: course.color }}>
                <img src={`${API_CONFIG.IMAGES_URL}/${course.icon}`} alt={`${course.title} icon`} className="course-icon" />
              </div>

              <p className="course-title">{course.title}</p>
            </Link>
          </div>
        ))}
      </div>
      <button className="pocustom-btn yellow-btn" onClick={handleBookDemoClick}>
        <img src={pencilIcon} alt="icon" className="pobtn-icon" />
        Book Free Demo Class
      </button>
    </div>
  );
};
const CodingPortal = () => {
  const [activeGrade, setActiveGrade] = useState("9-12");

  const handleGradeChange = (grade) => {
    setActiveGrade(grade);
  };

  const codingpage = heroContent.codingpage;

  // Scroll to the top when the component is mounted
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* <GuestNav /> */}
      <HeadSection
        leftImg={'Polymath-images/Codingleftimg.png'}
        rightImg={'Polymath-images/Codingrightimg.png'}
        titlePart1="Build Logical Minds Through Fun"
        titlePart2="& Interactive Coding Courses"
        description="In today’s digital world, coding is more than just a technical skill—it’s a vital life skill. At Polymath-Kids, our age-appropriate and engaging coding courses empower children to build logical thinking, creativity, and problem-solving abilities, preparing them to excel in the 21st century."
        button1Text={false}
        button2Text="Book Free Demo Class"
        button1Icon={'Polymath-images/pencil.png'}
        button2Icon={'Polymath-images/pencil.png'}
        onButton1Click={() => alert("Early bird discount clicked!")}
        onButton2Click={() => alert("Book demo clicked!")}
      />
      <CodingPopularCourses />

      <CourseSection />
      <LearningStyle />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};

export default CodingPortal;
